import React, { useEffect, useState } from "react";
import {
  Bar,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  ComposedChart,
  LabelList,
  Legend
} from "recharts";
import { PrAnalysisApi } from "../../../../../api/Api";
import { FaCrosshairs } from 'react-icons/fa';
import { jsPDF } from "jspdf";
import "jspdf-autotable"; // Ensure you import the autoTable plugin
import * as XLSX from "xlsx";
import logo from '../../../../../assets/img/logos/LTlogo.jpeg';
// import { getDateTimeForDashboardTab1, getFromTo } from '../../../../../utils'
import { AuthenticationContext } from "../../../../../context/AuthenticationContext";
import {
  Box,
  Card,
  CardContent,
  Grid,
  Typography,
  useTheme,
  CardActions,
  Button
} from "@mui/material";
import PrAnalysisTab2 from "./PrAnalysisTab2";


// Function to get default dates
export function getDateTimeForDashboardTab1(date = new Date()) {
  const formattedCurrentDate = date.toISOString().split("T")[0]; // Format: YYYY-MM-DD
  const tenDaysAgo = new Date(date);
  tenDaysAgo.setDate(tenDaysAgo.getDate() - 10);
  const formattedTenDaysAgo = tenDaysAgo.toISOString().split("T")[0]; // Format: YYYY-MM-DD

  return {
    Today: formattedCurrentDate,
    LastDay: formattedTenDaysAgo,
  };
}

const PrAnalysisTab1 = () => {
  const {LoggedInUserInfo} = React.useContext(AuthenticationContext)
  const [StartDate, setStartDate] = useState(getDateTimeForDashboardTab1().LastDay);
  const [EndDate, setEndDate] = useState(getDateTimeForDashboardTab1().Today);

  const [chartData, setChartData] = useState([]);
  const [chartData2, setChartData2] = useState([]);
  const [chartData3, setChartData3] = useState([]);
  const [chartData4, setChartData4] = useState([]);
  const [chartData5, setChartData5] = useState([]);
  const [chartData6, setChartData6] = useState([]);
  const theme = useTheme();
 const { palette, spacing, shape: { borderRadius } } = useTheme()

  // Pagination States
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [logData, setLogData] = useState([])
  const [loading, setLoading] = useState(true);

  // console.log("startdate", StartDate)
  // console.log("enddate", EndDate)
  const credentials = {
    USER: sessionStorage.getItem("LoginID") ?? "",
    LCODE: sessionStorage.getItem("LCODE") ?? "",
    PASS_KEY: sessionStorage.getItem("PASS_KEY") || "XYZ",
    WEB_KEY: sessionStorage.getItem("WEB_KEY") || "WEBXYZ321",
    DT1: StartDate, // Default Start Date
    DT2: EndDate, // Default End Date
  };

  // Fetch data from the API
  const fetchLogData = async () => {
    setLoading(false);
    try {
      const res = await PrAnalysisApi(credentials);


      if (res?.data && Array.isArray(res.data)) {
        console.log("Fetched Data:", res.data);
        setLogData(res.data);

        // Transform the API data of Chart1
        const transformedData = res.data.map((item) => ({
          name: item.DATET || "N/A", // Use `DATET` for labels on X-axis
          PR: parseFloat(item.PR) || 0, // PR value
          CUF: parseFloat(item.CUF) || 0, // CUF value
        }));

        setChartData(transformedData);

        // Transform the API data of chart2
        const transformedData2 = res.data.map((item) => ({
          name: item.DATET || "N/A", // Use `DATET` for labels on X-axis
          Solar_Insolation: parseFloat(item.Solar_Insolation) || 0, // PR value
          PR: parseFloat(item.PR) || 0, // CUF value
        }));

        setChartData2(transformedData2);

        // Transform the API data of chart3
        const transformedData3 = res.data.map((item) => ({
          name: item.DATET || "N/A", // Use `DATET` for labels on X-axis
          ENG: parseFloat(item.ENG) || 0, // PR value
          CUF: parseFloat(item.CUF) || 0, // CUF value
        }));

        setChartData3(transformedData3);

        // Transform the API data of chart4
        const transformedData4 = res.data.map((item) => ({
          name: item.DATET || "N/A", // Use `DATET` for labels on X-axis
          ENG: parseFloat(item.ENG) || 0, // PR value
          Specific_Yield: parseFloat(item.Specific_Yield) || 0, // CUF value
        }));

        setChartData4(transformedData4);

        // Transform the API data of chart5
        const transformedData5 = res.data.map((item) => ({
          name: item.DATET || "N/A", // Use `DATET` for labels on X-axis
          ENG: parseFloat(item.ENG) || 0, // PR value
          Expected_Generation: parseFloat(item.Expected_Generation) || 0, // CUF value
        }));

        setChartData5(transformedData5);

        // Transform the API data of chart6
        const transformedData6 = res.data.map((item) => ({
          name: item.DATET || "N/A", // Use `DATET` for labels on X-axis
          ENG: parseFloat(item.ENG) || 0, // PR value
          PR: parseFloat(item.PR) || 0, // CUF value
        }));

        setChartData6(transformedData6);

      } else {
        console.error("Data structure mismatch:", res);
        setChartData([]); // Handle invalid data response
        setChartData2([]); // Handle invalid data response
        setChartData3([]); // Handle invalid data response
        setChartData4([]); // Handle invalid data response
        setChartData5([]); // Handle invalid data response
        setChartData6([]); // Handle invalid data response
      }
    } catch (err) {
      console.error("Error fetching data:", err);
    }
  };

  // Fetch data on component mount
  // useEffect(() => {
  //   fetchLogData();
  // }, [StartDate, EndDate]);

  useEffect(() => {
    fetchLogData();
  }, []);


  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentData = logData.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(logData.length / itemsPerPage);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

// Define keys to exclude (you can also define keys to include instead)
const excludeKeys = ["NO", "KWP","KW_MAX","KW_MAX_DATE","USER"]; // Replace "key1", "key2" with actual keys you don't want to export

// Filter logData
const filteredLogData = logData.map((item) => {
  const filteredItem = {};
  Object.keys(item).forEach((key) => {
    if (!excludeKeys.includes(key)) {
      filteredItem[key] = item[key]; // Include keys not in excludeKeys
    }
  });
  return filteredItem;
});

// Get table headers from filteredLogData
const tableHeaders = filteredLogData.length > 0 ? Object.keys(filteredLogData[0]) : [];

  // Export to Excel
  const exportToExcel = () => {
    const ws = XLSX.utils.json_to_sheet(filteredLogData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "PrAnalysis");
    XLSX.writeFile(wb, `PrAnalysis To ${EndDate.replace(" ", "T")} PrAnalysis.xls`);
  };

  // Export to PDF
  const exportToPDF = () => {
    const doc = new jsPDF();

    // Add Logo (x, y, width, height)
    const imgWidth = 30;  // Adjust width
    const imgHeight = 20; // Adjust height
    const xPos = (doc.internal.pageSize.width - imgWidth) / 2;  // Center horizontally
    doc.addImage(logo, 'PNG', xPos, 10, imgWidth, imgHeight);  // Add logo at top

    // Add Title or Text Below the Logo
    const title = `PrAnalysis To ${EndDate.replace(" ", "T")}`;
    doc.setFontSize(12);  // Adjust font size
    doc.text(title, doc.internal.pageSize.width / 2, 35, { align: 'center' });  // Center text below logo

    // Adjust Y position for the table to start below the text
    let startY = 50;  // Push table further down below text

    doc.autoTable({
      head: [tableHeaders],
      body: currentData.map((item) => tableHeaders.map((key) => item[key])),
      startY: startY,  // Start table below the logo and text
      theme: "grid",
    });

    doc.save(`PrAnalysis To ${EndDate.replace(" ", "T")} PrAnalysis`);
  };

  // Handle Start Date change
  const handleStartDateChange = (value) => {
    setStartDate(value); // Update the StartDate directly
  };

  // Handle End Date change
  const handleEndDateChange = (value) => {
    setEndDate(value); // Update the EndDate directly
  };

  // Refresh data only when clicking "Show"
function onRefreshData() {
  if (StartDate.length !== 0 && EndDate.length !== 0) {
      fetchLogData(); // Fetch data only after clicking the button
  } else {
      alert("Please provide valid dates");
  }
}

  return (
    <Box bgcolor={"black"} py={0}>

      <Grid container spacing={spacing(0.3)} flexGrow={1} sx={{ mt: 0 }}>
        <Grid key="chart-grid" item xs={12}>
          <Card>
            <CardActions sx={{
              display: "flex", // Enable flexbox
              justifyContent: "flex-end", // Align items to the right
              alignItems: "center", // Center items vertically
              gap: "16px", // Add some spacing between the inputs
            }}>
              <label>
              From:&nbsp;
                <input
                  type="date"
                  value={StartDate} // Use StartDate directly
                  onChange={(e) => handleStartDateChange(e.target.value)}
                  style={{
                    padding: "2px 2px",
                    borderRadius: "14px",
                    border: "1px solid #ccc",
                  }}
                />
              </label>
              <label>
                To:&nbsp;
                <input
                  type="date"
                  value={EndDate} // Use EndDate directly
                  onChange={(e) => handleEndDateChange(e.target.value)}
                  style={{
                    padding: "2px 2px",
                    borderRadius: "14px",
                    border: "1px solid #ccc",
                  }}
                />
              </label>

               <Button onClick={onRefreshData} variant='contained' sx={{ color: 'white', p: 0, m: 0, fontSize: '12px', backgroundColor: palette.tintBlue, borderRadius: borderRadius }}>Show</Button>
            </CardActions>
          </Card>
        </Grid>


      </Grid>

      <Grid container spacing={1} flexGrow={1} sx={{ mt: 0 }}>
        <Grid item xs={12} md={6}>
          <Card>
            {/* Heading Box using Material UI Box */}
            <Box
              sx={{
                padding: "4px",
                borderRadius: "5px",
                marginBottom: "15px",
                textAlign: "start",
                fontWeight: "bold",
                fontSize: "16px",
                border: "1px solid lightgray",
                display: "flex",
                alignItems: "center",
              }}
            >
              <div className="left" style={{ marginRight: "10rem" }}>
                <FaCrosshairs style={{ marginRight: '10px', color: 'black' }} />
                PR Vs. CUF Curve
              </div>

            </Box>

            <CardContent sx={{ padding: "2px" }}>
              {chartData.length > 0 ? (
                <ResponsiveContainer width="100%" height={400}>
                  <ComposedChart data={chartData}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="name" 
                     stroke="white" // ✅ axis line and ticks
                     tick={{ fill: "white" }} // ✅ tick text color
                    />
                    <YAxis
                      yAxisId="left"
                      stroke="white" // ✅ axis line and ticks
                      
                      label={{
                        value: "PR",
                        angle: -90,
                        position: "insideLeft",
                        fill:"white"
                      }}
                     />
                    <YAxis
                      yAxisId="right"
                      stroke="white" // ✅ axis line and ticks
                    
                      orientation="right"
                      label={{
                        value: "CUF",
                        angle: 90,
                        position: "insideRight",
                        fill:"white"
                      }}
                    />
                    <Tooltip />

                    {/* Add Legend at the Top */}
                    <Legend
                      layout="horizontal" // Arranges items in a horizontal row
                      verticalAlign="top" // Positions the legend at the top
                      align="center" // Centers the legend horizontally
                      wrapperStyle={{ paddingBottom: "10px" }} // Adds some spacing below the legend
                    />

                    {/* PR Bar */}
                    <Bar
                      dataKey="PR"
                      fill={LoggedInUserInfo.dash_color}
                      name="PR"
                      yAxisId="left"
                    >
                      <LabelList
                        dataKey="PR"
                        position="top"
                        style={{
                          fill: LoggedInUserInfo.dash_color,
                          fontSize: "12px",
                          fontWeight: "bold",
                        }}
                      />
                    </Bar>

                    {/* CUF Line */}
                    <Line
                      type="monotone"
                      dataKey="CUF"
                      stroke="red"
                      name="CUF"
                      yAxisId="right"
                      strokeWidth={2}
                    >
                      <LabelList
                        dataKey="CUF"
                        position="top"
                        style={{
                          fill: "red",
                          fontSize: "12px",
                          fontWeight: "bold",
                        }}
                      />
                    </Line>
                  </ComposedChart>
                </ResponsiveContainer>
              ) : (
                <Typography
                  variant="body1"
                  color="textSecondary"
                  textAlign="center"
                >
                  No data available for the selected range.
                </Typography>
              )}
            </CardContent>


          </Card>
        </Grid>

        <Grid item xs={12} md={6}>
          <Card>

            <Box
              sx={{
                padding: "4px",
                borderRadius: "5px",
                marginBottom: "15px",
                textAlign: "start",
                fontWeight: "bold",
                fontSize: "16px",
                border: "1px solid lightgray",
                display: "flex",
                alignItems: "center",
              }}
            >
              <FaCrosshairs style={{ marginRight: '10px', color: 'black' }} />
              Solar Insolation Vs. PR Curve

            </Box>

            <CardContent sx={{ padding: "2px" }}>
              {chartData2.length > 0 ? (
                <ResponsiveContainer width="100%" height={400}>
                  <ComposedChart
                    data={chartData2}
                    margin={{ top: 10, right: 10, left: 10, bottom: 5 }}
                  >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="name"
                     stroke="white" // ✅ axis line and ticks
                     tick={{ fill: "white" }} // ✅ tick text color
                     />
                    <YAxis
                      yAxisId="left"
                      stroke="white" // ✅ axis line and ticks
                      
                      label={{
                        value: "Solar_Insolation",
                        angle: -90,
                        position: "insideLeft",
                        fill:"white"
                      }}
                    />
                    <YAxis
                      yAxisId="right"
                      stroke="white" // ✅ axis line and ticks
                      
                      orientation="right"
                      label={{
                        value: "PR",
                        angle: 90,
                        position: "insideRight",
                        fill:"white"
                      }}
                    />
                    <Tooltip />

                    {/* Add Legend */}
                    <Legend
                      layout="horizontal" // Horizontal alignment of legend items
                      verticalAlign="top" // Position the legend at the top of the chart
                      align="center" // Center-align the legend horizontally
                      wrapperStyle={{
                        paddingBottom: "10px", // Add spacing below the legend
                        fontSize: "12px", // Adjust font size
                      }}
                    />

                    {/* Solar Insolation Bar */}
                    <Bar
                      dataKey="Solar_Insolation"
                      fill={LoggedInUserInfo.dash_color}
                      name="Solar Insolation" // Legend label
                      yAxisId="left"
                    >
                      <LabelList
                        dataKey="Solar_Insolation"
                        position="top"
                        style={{
                          fill:LoggedInUserInfo.dash_color,
                          fontSize: "12px",
                          fontWeight: "bold",
                        }}
                      />
                    </Bar>

                    {/* PR Line */}
                    <Line
                      type="monotone"
                      dataKey="PR"
                      stroke="red"
                      name="PR" // Legend label
                      yAxisId="right"
                      strokeWidth={2}
                    >
                      <LabelList
                        dataKey="PR"
                        position="top"
                        style={{
                          fill: "red",
                          fontSize: "12px",
                          fontWeight: "bold",
                        }}
                      />
                    </Line>
                  </ComposedChart>
                </ResponsiveContainer>
              ) : (
                <Typography
                  variant="body1"
                  color="textSecondary"
                  textAlign="center"
                >
                  No data available for the selected range.
                </Typography>
              )}
            </CardContent>


          </Card>
        </Grid>

      </Grid>


      <Grid container spacing={1} flexGrow={1} sx={{ mt: 0 }}>
        <Grid item xs={12} md={6}>
          <Card>
            {/* Heading Box using Material UI Box */}
            <Box
              sx={{
                padding: "4px",
                borderRadius: "5px",
                marginBottom: "15px",
                textAlign: "start",
                fontWeight: "bold",
                fontSize: "16px",
                border: "1px solid lightgray",
                display: "flex",
                alignItems: "center",
              }}
            >
              <FaCrosshairs style={{ marginRight: '10px', color: 'black' }} />
              Energy Generation Vs. CUF Curve
            </Box>

            <CardContent sx={{ padding: "2px" }}>
              {chartData3.length > 0 ? (
                <ResponsiveContainer width="100%" height={400}>
                  <ComposedChart
                    data={chartData3}
                    margin={{ top: 10, right: 10, left: 10, bottom: 5 }}
                  >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="name"
                     stroke="white" // ✅ axis line and ticks
                     tick={{ fill: "white" }} // ✅ tick text color
                    />
                    <YAxis
                      yAxisId="left"
                      stroke="white" // ✅ axis line and ticks
                      
                      label={{
                        value: "ENG",
                        angle: -90,
                        position: "insideLeft",
                        fill:"white"
                      }}
                    />
                    <YAxis
                      yAxisId="right"
                      stroke="white" // ✅ axis line and ticks
                     
                      orientation="right"
                      label={{
                        value: "CUF",
                        angle: 90,
                        position: "insideRight",
                        fill:"white"
                      }}
                    />
                    <Tooltip />

                    {/* Add Legend */}
                    <Legend
                      layout="horizontal"
                      verticalAlign="top"
                      align="center"
                      wrapperStyle={{
                        paddingBottom: "10px", // Space between legend and chart
                        fontSize: "12px", // Adjust font size
                      }}
                    />

                    {/* ENG Bar */}
                    <Bar
                      dataKey="ENG"
                      fill={LoggedInUserInfo.dash_color}
                      name="ENG" // Legend label for ENG
                      yAxisId="left"
                    >
                      <LabelList
                        dataKey="ENG"
                        position="top"
                        style={{
                          fill: LoggedInUserInfo.dash_color,
                          fontSize: "12px",
                          fontWeight: "bold",
                        }}
                      />
                    </Bar>

                    {/* CUF Line */}
                    <Line
                      type="monotone"
                      dataKey="CUF"
                      stroke="red"
                      name="CUF" // Legend label for CUF
                      yAxisId="right"
                      strokeWidth={2}
                    >
                      <LabelList
                        dataKey="CUF"
                        position="top"
                        style={{
                          fill: "red",
                          fontSize: "12px",
                          fontWeight: "bold",
                        }}
                      />
                    </Line>
                  </ComposedChart>
                </ResponsiveContainer>
              ) : (
                <Typography
                  variant="body1"
                  color="textSecondary"
                  textAlign="center"
                >
                  No data available for the selected range.
                </Typography>
              )}
            </CardContent>


          </Card>
        </Grid>

        <Grid item xs={12} md={6}>
          <Card>
            {/* Heading Box using Material UI Box */}
            <Box
              sx={{
                padding: "4px",
                borderRadius: "5px",
                marginBottom: "15px",
                textAlign: "start",
                fontWeight: "bold",
                fontSize: "16px",
                border: "1px solid lightgray",
                display: "flex",
                alignItems: "center",
              }}
            >
              <FaCrosshairs style={{ marginRight: '10px', color: 'black' }} />
              Energy Generation Vs. Specific Yield
            </Box>

            <CardContent sx={{ padding: "2px" }}>
              {chartData3.length > 0 ? (
                <ResponsiveContainer width="100%" height={400}>
                  <ComposedChart
                    data={chartData4}
                    margin={{ top: 10, right: 10, left: 10, bottom: 5 }}
                  >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="name" 
                     stroke="white" // ✅ axis line and ticks
                     tick={{ fill: "white" }} // ✅ tick text color
                    />
                    <YAxis
                      yAxisId="left"
                      stroke="white" // ✅ axis line and ticks
                     
                      label={{
                        value: "ENG",
                        angle: -90,
                        position: "insideLeft",
                        fill:"white"
                      }}
                    />
                    <YAxis
                      yAxisId="right"
                      stroke="white" // ✅ axis line and ticks
                    
                      orientation="right"
                      label={{
                        value: "Specific_Yield",
                        angle: 90,
                        position: "insideRight",
                        fill:"white"
                      }}
                    />
                    <Tooltip />

                    {/* Add Legend */}
                    <Legend
                      layout="horizontal"
                      verticalAlign="top"
                      align="center"
                      wrapperStyle={{
                        paddingBottom: "10px", // Space between legend and chart
                        fontSize: "12px", // Adjust font size
                      }}
                    />

                    {/* ENG Bar */}
                    <Bar
                      dataKey="ENG"
                      fill={LoggedInUserInfo.dash_color}
                      name="ENG" // Legend label for ENG
                      yAxisId="left"
                    >
                      <LabelList
                        dataKey="ENG"
                        position="top"
                        style={{
                          fill: LoggedInUserInfo.dash_color,
                          fontSize: "12px",
                          fontWeight: "bold",
                        }}
                      />
                    </Bar>

                    {/* Specific_Yield Line */}
                    <Line
                      type="monotone"
                      dataKey="Specific_Yield"
                      stroke="red"
                      name="Specific_Yield" // Legend label for Specific_Yield
                      yAxisId="right"
                      strokeWidth={2}
                    >
                      <LabelList
                        dataKey="Specific_Yield"
                        position="top"
                        style={{
                          fill: "red",
                          fontSize: "12px",
                          fontWeight: "bold",
                        }}
                      />
                    </Line>
                  </ComposedChart>
                </ResponsiveContainer>
              ) : (
                <Typography
                  variant="body1"
                  color="textSecondary"
                  textAlign="center"
                >
                  No data available for the selected range.
                </Typography>
              )}
            </CardContent>


          </Card>
        </Grid>

      </Grid>

      <Grid container spacing={1} flexGrow={1} sx={{ mt: 0 }}>

        <Grid item xs={12} md={6}>
          <Card>
            {/* Heading Box using Material UI Box */}
            <Box
              sx={{
                padding: "4px",
                borderRadius: "5px",
                marginBottom: "15px",
                textAlign: "start",
                fontWeight: "bold",
                fontSize: "16px",
                border: "1px solid lightgray",
                display: "flex",
                alignItems: "center",
              }}
            >
              <FaCrosshairs style={{ marginRight: '10px', color: 'black' }} />
              Energy Generation Vs. Expected Generation
            </Box>

            <CardContent sx={{ padding: "2px" }}>
              {chartData3.length > 0 ? (
                <ResponsiveContainer width="100%" height={400}>
                  <ComposedChart
                    data={chartData5}
                    margin={{ top: 10, right: 10, left: 10, bottom: 5 }}
                  >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="name" 
                     stroke="white" // ✅ axis line and ticks
                     tick={{ fill: "white" }} // ✅ tick text color
                    />
                    <YAxis
                      yAxisId="left"
                      stroke="white" // ✅ axis line and ticks
                      
                      label={{
                        value: "ENG",
                        angle: -90,
                        position: "insideLeft",
                        fill:"white"
                      }}
                    />
                    <YAxis
                      yAxisId="right"
                      stroke="white" // ✅ axis line and ticks
                     
                      orientation="right"
                      label={{
                        value: "Expected_Generation",
                        angle: 90,
                        position: "insideRight",
                        fill:"white"
                      }}
                    />
                    <Tooltip />

                    {/* Add Legend */}
                    <Legend
                      layout="horizontal"
                      verticalAlign="top"
                      align="center"
                      wrapperStyle={{
                        paddingBottom: "10px", // Space between legend and chart
                        fontSize: "12px", // Adjust font size
                      }}
                    />

                    {/* ENG Bar */}
                    <Bar
                      dataKey="ENG"
                      fill={LoggedInUserInfo.dash_color}
                      name="ENG" // Legend label for ENG
                      yAxisId="left"
                    >
                      <LabelList
                        dataKey="ENG"
                        position="top"
                        style={{
                          fill: LoggedInUserInfo.dash_color,
                          fontSize: "12px",
                          fontWeight: "bold",
                        }}
                      />
                    </Bar>

                    {/* Expected_Generation Line */}
                    <Line
                      type="monotone"
                      dataKey="Expected_Generation"
                      stroke="red"
                      name="Expected_Generation" // Legend label for Expected_Generation
                      yAxisId="right"
                      strokeWidth={2}
                    >
                      <LabelList
                        dataKey="Expected_Generation"
                        position="top"
                        style={{
                          fill: "red",
                          fontSize: "12px",
                          fontWeight: "bold",
                        }}
                      />
                    </Line>
                  </ComposedChart>
                </ResponsiveContainer>
              ) : (
                <Typography
                  variant="body1"
                  color="textSecondary"
                  textAlign="center"
                >
                  No data available for the selected range.
                </Typography>
              )}
            </CardContent>
          </Card>
        </Grid>


        <Grid item xs={12} md={6}>
          <Card>
            {/* Heading Box using Material UI Box */}
            <Box
              sx={{
                padding: "4px",
                borderRadius: "5px",
                marginBottom: "15px",
                textAlign: "start",
                fontWeight: "bold",
                fontSize: "16px",
                border: "1px solid lightgray",
                display: "flex",
                alignItems: "center",
              }}
            >
              <FaCrosshairs style={{ marginRight: '10px', color: 'black' }} />
              Energy Generation Vs. PR
            </Box>

            <CardContent sx={{ padding: "2px" }}>
              {chartData3.length > 0 ? (
                <ResponsiveContainer width="100%" height={400}>
                  <ComposedChart
                    data={chartData6}
                    margin={{ top: 10, right: 10, left: 10, bottom: 5 }}
                  >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="name" 
                     stroke="white" // ✅ axis line and ticks
                     tick={{ fill: "white" }} // ✅ tick text color
                    />
                    <YAxis
                      yAxisId="left"
                      stroke="white" // ✅ axis line and ticks
                     
                      label={{
                        value: "ENG",
                        angle: -90,
                        position: "insideLeft",
                        fill:"white"
                      }}
                    />
                    <YAxis
                      yAxisId="right"
                      stroke="white" // ✅ axis line and ticks
                      
                      orientation="right"
                      label={{
                        value: "PR",
                        angle: 90,
                        position: "insideRight",
                        fill:"white"
                      }}
                    />
                    <Tooltip />

                    {/* Add Legend */}
                    <Legend
                      layout="horizontal"
                      verticalAlign="top"
                      align="center"
                      wrapperStyle={{
                        paddingBottom: "10px", // Space between legend and chart
                        fontSize: "12px", // Adjust font size
                      }}
                    />

                    {/* ENG Bar */}
                    <Bar
                      dataKey="ENG"
                      fill={LoggedInUserInfo.dash_color}
                      name="ENG" // Legend label for ENG
                      yAxisId="left"
                    >
                      <LabelList
                        dataKey="ENG"
                        position="top"
                        style={{
                          fill:LoggedInUserInfo.dash_color,
                          fontSize: "12px",
                          fontWeight: "bold",
                        }}
                      />
                    </Bar>

                    {/* Expected_Generation Line */}
                    <Line
                      type="monotone"
                      dataKey="PR"
                      stroke="red"
                      name="PR" // Legend label for Expected_Generation
                      yAxisId="right"
                      strokeWidth={2}
                    >
                      <LabelList
                        dataKey="PR"
                        position="top"
                        style={{
                          fill: "red",
                          fontSize: "12px",
                          fontWeight: "bold",
                        }}
                      />
                    </Line>
                  </ComposedChart>
                </ResponsiveContainer>
              ) : (
                <Typography
                  variant="body1"
                  color="textSecondary"
                  textAlign="center"
                >
                  No data available for the selected range.
                </Typography>
              )}
            </CardContent>
          </Card>
        </Grid>


      </Grid>

      <div style={{ padding: "0px", marginTop: ".5rem" }}>
        {/* Controls */}
        <div className="row">
          <div className="col-md-12">
            <div style={containerStyle} className="head">
              <p style={responsiveHeaderStyle}>PR Analysis</p>
              <div style={responsiveControlsStyle}>

                <button onClick={fetchLogData} style={buttonStyle}>
                  Show
                </button>
                <button onClick={exportToExcel} style={exportButtonStyle}>
                  Excel
                </button>
                <button onClick={exportToPDF} style={exportButtonStyle2}>
                  PDF
                </button>


              </div>
            </div>
          </div>
        </div>
        {/* Table */}
        <div className="table-responsive">
          <table className="table table-hover table-bordered">
            <thead className="text-center" style={{ backgroundColor: "rgb(253, 248, 228)" }}>
              <tr>
                <th style={tableHeading}> Date </th>
                <th style={tableHeading}>Energy</th>
                <th style={tableHeading}> CUF </th>
                <th style={tableHeading}> PR </th>
                <th style={tableHeading}> Capacity </th>
                <th style={tableHeading}>Specific Yield</th>
                <th style={tableHeading}> Solar Insolation</th>
                <th style={tableHeading}>Expected Generation</th>
                <th style={tableHeading}>Peak Radiation </th>
                <th style={tableHeading}>Peak Radiation Time </th>


              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan={tableHeaders.length} className="text-center">
                    Loading...
                  </td>
                </tr>
              ) : currentData.length > 0 ? (
                currentData.map((item, rowIndex) => (
                  <tr key={rowIndex}>
                    
                      <td className="text-center align-middle" style={tableBody}>
                        {item.DATET ?? ""}
                      </td>

                      <td className="text-center align-middle" style={tableBody}>
                        {item.ENG ?? ""}
                      </td>

                      <td className="text-center align-middle" style={tableBody}>
                        {item.CUF?? ""}
                      </td>
                      <td className="text-center align-middle" style={tableBody}>
                        {item.PR ?? ""}
                      </td>
                      <td className="text-center align-middle" style={tableBody}>
                        {item.CAP ?? ""}
                      </td>
                      <td className="text-center align-middle" style={tableBody}>
                        {item.Specific_Yield ?? ""}
                      </td>
                      <td className="text-center align-middle" style={tableBody}>
                        {item.Solar_Insolation ?? ""}
                      </td>

                      <td className="text-center align-middle" style={tableBody}>
                        {item.Expected_Generation ?? ""}
                      </td>

                      <td className="text-center align-middle" style={tableBody}>
                        {item.PEAK_RADIATION ?? ""}
                      </td>

                      <td className="text-center align-middle" style={tableBody}>
                        {item.PEAK_RADIATION_DATE?? ""}
                      </td>
                   
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={tableHeaders.length} className="text-center">
                    No data available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        {/* <div style={{ textAlign: "right", marginTop: "0px" }}>
          <button
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
            style={paginationButtonStyle}
          >
            Previous
          </button>
          {[...Array(totalPages)].map((_, index) => (
            <button
              key={index}
              onClick={() => handlePageChange(index + 1)}
              style={{
                ...paginationButtonStyle,
                backgroundColor: currentPage === index + 1 ? "#007bff" : "#007bff",
                color: currentPage === index + 1 ? "#fff" : "#fff",
              }}
            >
              {index + 1}
            </button>
          ))}
          <button
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
            style={paginationButtonStyle}
          >
            Next
          </button>
        </div> */}
        <div style={{ textAlign: "right", marginTop: "10px" }}>
          <button
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
            style={paginationButtonStyle}
          >
            Previous
          </button>

          {[...Array(totalPages)].map((_, index) => {
            const isActive = currentPage === index + 1;
            return (
              <button
                key={index}
                onClick={() => handlePageChange(index + 1)}
                style={{
                  ...paginationButtonStyle,
                  backgroundColor: isActive ? "#356E35" : "white",
                  color: isActive ? "#fff" : "#356E35",
                }}
              >
                {index + 1}
              </button>
            );
          })}

          <button
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
            style={paginationButtonStyle}
          >
            Next
          </button>
        </div>
      </div>

    </Box>
  );
};

export default PrAnalysisTab1;



/* Styles */

const containerStyle = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  flexWrap: "wrap",
   marginBottom: ".3rem",
  border: "1px solid lightgray",
  padding: "3px",
  // borderRadius: "7px"
  backgroundColor:"white",
  color:"black"
};

const responsiveHeaderStyle = {
  fontWeight: "bold",
  margin: "0",
  display: "flex",
  flexWrap: "wrap"
};

const responsiveControlsStyle = {
  display: "flex",
  flexWrap: "wrap",
  gap: "10px",
  justifyContent: "center",
};

const inputStyle = {
  padding: "2px 2px",
  borderRadius: "14px",
  border: "1px solid #ccc",
  // marginLeft: "5px",
  // fontSize: "10px",
};

const buttonStyle = {
  backgroundColor: "#007BFF",
  color: "#fff",
  border: "none",
  borderRadius: "14px",
  padding: "2px 9px",
  cursor: "pointer",
  fontSize: "10px",
};

const exportButtonStyle = {
  backgroundColor: "darkblue",
  color: "#fff",
  border: "none",
  borderRadius: "14px",
  padding: "3px 9px",
  cursor: "pointer",
  fontSize: "11px",
};

const exportButtonStyle2 = {
  backgroundColor: "#f44336",
  color: "#fff",
  border: "none",
  borderRadius: "14px",
  padding: "3px 9px",
  cursor: "pointer",
  fontSize: "11px",
};

const paginationButtonStyle = {
  backgroundColor: "white",
  color: "#007bff",
  border: "1px solid #ddd",
  padding: "5px 10px",
  borderRadius: "5px",
  margin: "0 5px",
  cursor: "pointer",
  fontSize: "14px",
};


const tableHeading = {
  color: "rgb(53, 110, 53)",
  padding: "12px 10px",
  fontSize: "14px",
  whiteSpace: "nowrap",
}

const tableBody={
  padding: "5px",
  whiteSpace: "nowrap",
}